<template>
  <v-dialog v-model="dialog" max-width="480px">
    <v-card>
      <v-card-title class="mx-3">
        {{ title ? title : $t("Import.import", [objName]) }}
        <v-spacer></v-spacer>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-icon v-bind="attrs" v-on="on" @click="dialog = false">
              fa-times
            </v-icon>
          </template>
          {{ $t("$vuetify.close") }}
        </v-tooltip>
      </v-card-title>
      <v-divider />
      <v-card-text class="px-4 py-8 text-center subtitle-1">
        <v-list-item three-line>
          <v-list-item-content>
            <v-list-item-title class="text-left my-2">
              {{ $t("Import.downloadFieldTemplate", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-row>
                <v-col cols="12" md="4" sm="4">
                  <SearcherStock v-model="stockSelected" />
                </v-col>
                <v-col cols="12" md="4" sm="4">
                  <SearcherSupplier v-model="supplierSelected" />
                </v-col>
                <v-col cols="12" md="4" sm="4" align-self="center">
                  <v-btn
                    color="primary"
                    dark
                    class="ms-1"
                    @click="templateDownload()"
                  >
                    {{ $t("Import.downloadFieldTemplateBtn") }}
                  </v-btn>
                </v-col>
                <v-col cols="12" md="12" sm="12" style="text-align: left;margin-top: -35px">
                  <span class="red--text">
                    {{ $t("PurchasesList.import.hint") }}
                  </span>
                </v-col>
              </v-row>
            </v-list-item-subtitle>
            <v-list-item-title class="text-left my-2">
              {{ $t("Import.uploadField", [objName]) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              <v-file-input
                v-model="excelFile"
                show-size
                :label="$t('Import.fileInputLabel')"
                accept=".xls,.xlsx"
              ></v-file-input>
            </v-list-item-subtitle>
            <span v-if="isTips">
              <v-list-item-title class="text-left my-2">
                {{ $t("$vuetify.alert") }}
              </v-list-item-title>
              <v-list-item-subtitle
                class="text-left my-1"
                v-for="detail in tipDetails"
                :key="detail"
              >
                {{ detail }}
              </v-list-item-subtitle>
            </span>
          </v-list-item-content>
        </v-list-item>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="secondary" outlined @click="dialog = false">
          {{ $t("$vuetify.close") }}
        </v-btn>
        <v-btn color="primary" depressed @click="$emit('import', excelFile)">
          {{ $t("Import.confirmImport") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import Purchases from "@/api/purchases";
import SearcherStock from "@/components/plugins/SearcherStock";
import SearcherSupplier from "@/components/plugins/SearcherSupplier";
import i18n from "@/i18n";
export default {
  name: "ImportExcelDialog",

  props: {
    value: Boolean,
    title: String,
    objName: String,
    isTips: Boolean,
    tipDetails: Array,
    downloadFromAPI: Boolean,
    downloadTemplateUrl: String,
  },
  components: {
    SearcherStock,
    SearcherSupplier,
  },
  data: () => ({
    dialog: false,
    excelFile: null,
    stockSelected: null,
    supplierSelected: null,
    stock_id: "",
    supplier_id: "",
  }),
  methods: {
    templateDownload() {
      if (this.stock_id == "" || this.supplier_id == "") {
        this.$snackbar.error(i18n.t("PurchasesList.import.hint"));
        return;
      }
      Purchases.templateExport({
        stock_id: this.stock_id,
        supplier_id: this.supplier_id,
      });
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.dialog = this.value;
      },
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.excelFile = null;
          this.stockSelected = null;
          this.supplierSelected = null;
          this.stock_id = "";
          this.supplier_id = "";
        }
        this.$emit("input", this.dialog);
      },
    },
    stockSelected: {
      handler() {
        this.stock_id = this.stockSelected ? this.stockSelected.id : "";
      },
    },
    supplierSelected: {
      handler() {
        this.supplier_id = this.supplierSelected
          ? this.supplierSelected.id
          : "";
      },
    },
  },
};
</script>